var axiosInstance = require("axios").create();

axiosInstance.interceptors.request.use(
  config => {
    // Do something before request is sent
    config.headers["X-Api-Key"] = process.env.VUE_APP_API_KEY;
    return config;
  },
  error => {
    // Do something with request error
    console.log("intreq", error);
    throw error;
  }
);

axiosInstance.interceptors.response.use(
  response => {
    // Do something before request is sent
    if (!response || response.status !== 200 || !response.data) {
      throw new Error("Bad response, check log");
    }
    const data = response.data;
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  },
  error => {
    // Do something with request error
    console.log("intres", error);
    throw error;
  }
);

export default {
  axios: axiosInstance
};
